import { render, staticRenderFns } from "./AllTransection.vue?vue&type=template&id=574e4b06&scoped=true&"
import script from "./AllTransection.vue?vue&type=script&lang=js&"
export * from "./AllTransection.vue?vue&type=script&lang=js&"
import style0 from "./AllTransection.vue?vue&type=style&index=0&id=574e4b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e4b06",
  null
  
)

export default component.exports